<template>
  <div class="content com-wage">
    <!--  -->
    <el-row style="height:3vh;padding-left: 0.5vw;padding-top: 0.1vh;">
      <el-col :span="24">
        <div class="grid-content bg-purple-dark">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
            <el-breadcrumb-item>劳务工资</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
      </el-col>
    </el-row>
    <!-- 主体 -->
    <el-container style="height:calc(100% - 3vh);width:100%;position: relative;">
      <!-- 侧边树 -->
      <el-aside width="16%" style="height:100%" class="aside">
        <el-card style="height:100%;overflow-y: auto;padding:1vh;">
          <el-tree
            :data="dataTree"
            ref="tree"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false"
            :highlight-current="true"
            @node-click="handleNodeClick"
            node-key="id"
            :current-node-key="currentNodekey"
            :default-expanded-keys="expandedkeys"
          > 
            <span class="span-ellipsis" slot-scope="{ node, data }" style="width: 100%;text-align: left;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">
              <span :title="node.label" class="">{{data.name}}</span>
            </span>
          </el-tree>
        </el-card>
      </el-aside>
      <!-- 右边 -->
      <el-main class="build-CURD" style="height: 100%;padding:0px !important; padding-left: 20px !important; position: relative;width: 84%;">
        <div style="width:100%;height:7vh;background: #fff;position: relative;display:flex;align-content: center;align-items: center;justify-content:space-between;padding: 0 1vw;">
          <div style="display:flex;padding:0 1vw;">
            <span style="width:20vw;display: inline-block;text-align: left;">累计实发：{{num.money||0}}元</span>
            <span style="width:30vw;display: inline-block;text-align: left;">累计人数：{{num.personCount||0}}</span>
            <!-- <el-input placeholder="请输入姓名" v-model="search.personName" clearable style="margin-right:1vw;"></el-input>
                <el-date-picker
                    v-model="search.applyMonth"
                    type="month"
                    @change="doFilter"
                    value-format="yyyy-MM"
                    placeholder="选择月份">
                </el-date-picker>
                <el-button type="primary" @click="doFilter" style="margin-left:1vw;">查询</el-button>
            </div>
            <div style="display:flex;">
                <el-tooltip class="item" effect="dark" content="工资表导出" placement="top-end" style="margin-left:30vw;">
                    <div class="tips">
                        <img @click="exportWorker" class="icon_hover" src="../../assets/image/icon/exportAtt.png" alt="" srcset="">
                        <span>劳务工资表导出</span>
                    </div>   
                </el-tooltip> -->
            </div>
        </div>
        <div style="width:100%;height:calc( 100% - 13vh );position: relative;">
            <el-table
              :data="listData"
              stripe
              border
              height="100%"
              style="width: 100%;"
              :header-cell-style="{background:'#F5F7F9',color:'#909399'}"
              >
              <template slot="empty">
                  <p>{{dataText}}</p>
              </template>
              <el-table-column label="序号" width="100">
                  <template slot-scope="scope">
                  <span>{{ scope.row.index }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="月份">
                  <template slot-scope="scope">
                  <span>{{ scope.row.applyMonth }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="实发人数">
                  <template slot-scope="scope">
                  <span>{{ scope.row.personCount }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="实发工资（元）">
                  <template slot-scope="scope">
                  <span>{{ scope.row.money }}</span>
                  </template>
              </el-table-column>
              <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="primary" @click="toList(scope.row)">查看</el-button>
                  </template>
              </el-table-column>
            </el-table>
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalItems"
            ></el-pagination>
        </div>
      </el-main>
    </el-container>
    <el-dialog
      title="选择时间"
      :visible.sync="dialogTime"
      width="30%">
      <el-form
          :model="addForm"
          ref="addForm"
          label-width="100px"
          :label-position="labelPosition"
          >
          <el-form-item label="月份：">
              <el-date-picker v-model="addForm.applyMonth" type="month" value-format="yyyy-MM" placeholder="选择月份"></el-date-picker>
          </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button @click="dialogTime = false">取 消</el-button>
          <el-button type="primary" @click="getExportFun">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import myHttp from '../../untils/port.js'
import util from '../../untils/util.js'
import base from '../../untils/base'
export default {
  data() {
    return {
      dataTree: [],
      defaultProps: {
        children: 'list',
        label: 'name'
      },
      currentNodekey: '', //默认选中的节点树
      expandedkeys: [], //默认展开的节点树
      projectId:'',//项目id
      joinType:'',//2：施工端    3：建设端
      proTypes:[],//项目类型

      search:{
          applyMonth:util.myTime.getCurMonth(),
          personName:'',
      },
      listData:[],//列表
      currentPage: 1,
      pageSize: 10,
      totalItems: 0,

      dialogTime:false,
      addForm:{
        applyMonth:util.myTime.getCurMonth(),
      },
      labelPosition:'right',
      dataText:'数据加载中...',
      num:{
        personCount:0,
        money:0,
      },
    }
  },
  created() {
    this.groupId = this.$store.state.groupId
  },
  mounted() {
    // this.getData()
    // this.getProType()
    this.joinType = util.session.get('roleId')=='3'?'3':''
    this.getAll() //获取组织树   
  },
  methods: {
    //项目类型
    getProType(){
      var that = this
      myHttp.getDictByType({
        type:'project_type'
      }).then(function(resp){
        if(resp.data.code=='200'){
          var list = resp.data.data.dictList||[]
          that.proTypes = list
          // for(var i=0;i<list.length;i++){
          //   if(that.form.projectType==list[i].value){
          //     that.proTypeName = list[i].label
          //   }
          // }
        }
      })
    },
    //获取所有项目
    getAll() {
      var that = this
      myHttp
        .getPageListPro({
          entId: this.groupId,
          joinType: this.joinType
        })
        .then(function(resp) {
          if (resp.data.code == '200') {
            var list = resp.data.data.entOfficeProjectMenu || []
            for(var i=0;i<list.length;i++){
              if(list[i].list.length>0 && that.projectId==''){
                that.projectId = list[i].list[0].id
                that.currentNodekey = list[i].list[0].id
                that.expandedkeys.push(list[i].list[0].id)
                that.$nextTick(() => {
                  // treeBox 元素的ref   value 绑定的node-key
                  that.$refs.tree.setCurrentKey(that.currentNodekey)
                })
                that.getData()
                that.getNum()
              }
            }
            that.dataTree = list
            
          }
        })
    },
    //点击树形结构
    handleNodeClick(data) {
      // console.log(data)
      if(data.list){
        return
      }else{
        this.projectId=data.id
        this.getData()
        this.getNum()
      }
    },

    //过滤
    doFilter(){
        this.getData()
    },
    //
    handleSizeChange(val) {
        this.pageSize = val
        this.handleCurrentChange(this.currentPage)
    },
    handleCurrentChange(val) {
        this.currentPage = val
        this.currentChangePage()
    },
    // 监控当前页码
    currentChangePage(list) {
        this.getData()
    },
   
    //获取数据
    getData() {
      var that = this
      this.search.entId = this.groupId
      this.search.projectId = this.projectId
      this.search.pageNum = this.currentPage
      this.search.pageSize = this.pageSize
      myHttp.selectSalayApplyByEntId(this.search).then(function(resp){
          if(resp.data.code=='200'){
              var list = resp.data.data.pageInfo.list||[]
              for(var i=0;i<list.length;i++){
                  list[i].index = (that.currentPage - 1) * that.pageSize + (i + 1)
              }
              that.listData = list
              that.totalItems = resp.data.data.pageInfo.total||0
              if(list.length==0){
                  that.dataText = '暂无数据'
              }
          }else{
              that.dataText = '暂无数据'
          }
      })
      
    },
    //获取总数
    getNum(){
      var that =this
      myHttp.selectSalayApplyAllCountByEntId({
        entId:this.groupId,
        projectId:this.projectId,
        joinType:''
      }).then(function(resp){
        console.log(resp)
        if(resp.data.code=='200'){
          var data = resp.data.data.entity
          if(data){
            that.num = data
          }
        }
      })
    },
    //获取区域
    setAreaFun(id) {
      if ('' == id || undefined == id) return
      var that = this
      myHttp.getAreaById({
          id: id
      }).then(
        function(resp) {
          if (resp.data.code == '200') {
            var province = resp.data.data.area.provinceId
            var city = resp.data.data.area.cityId
            var area = resp.data.data.area.countyId
            if (resp.data.data.area.level == '3' && undefined == area) {
              area = resp.data.data.area.id
            }
            var arry = []
            arry.push(province)
            arry.push(city)
            arry.push(area)
            that.selectedOptions = arry
            // console.log(that.selectedOptions)
            // that.getData()
          }
        },
        function(error) {}
      )
    },
    downLine(){
      this.downFlag = true
    },
    upLine(){
      this.downFlag = false
    },

    //导出
    exportWorker(){
      this.dialogTime = true
      this.addForm.applyMonth = util.myTime.getCurMonth()
    },
    getExportFun(){
        this.dialogTime = false
        var token = util.session.get('token')
        window.open(myHttp.exportTeamsApplyDetailByConditions+'?projectId='+this.groupId+'&applyMonth='+this.addForm.applyMonth+'&accessToken='+token)
        
    },

    //查看列表
    toList(row){
      this.$router.push({path:'/comWageGzList/'+row.projectId+'/'+row.applyMonth})
    },

  }
}
</script>

<style scoped>
/* .content {
  height: 100%;
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-direction: column;
  flex-direction: column;
  padding: 1%;
} */
.grid-content {
  height: 2.5vh;
  font-size: 1.6vh;
}
.aside {
  box-shadow: rgba(8, 42, 51, 0.1) 0px 0px 7px 0px !important;
  border-radius: 10px !important;
  border: 0px !important;
  background-color: rgb(255, 255, 255);
}
/* .grid-search {
  display: flex;
  justify-content: space-between;
  margin: 0px 20px 0;
  height: 66px;
} */
.content >>> .el-card__body {
  padding: 0 !important;
  height: 100% !important;
}
.build-table {
  height: calc(100% - 80px);
}
.active {
  background: #409eff;
  color: #fff;
}
.contract-con {
  width: 100%;
  background: #fff;
  height: 125px;
  font-size: 14px;
}
.contract-con p {
  width: 100%;
  padding: 2px 20px;
  text-align: left;
}
.content >>> .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  color: #4d95fd;
  /* font-weight: bold; */
}
.content >>>.el-input-group--append .el-input__inner{
  width: 200px;
}

/*  */
.proName-box {
  background: #fff;
  padding: 20px 60px;
}
.pro-box1,
.pro-box3,
.pro-box4 {
  display: flex;
  width: 100%;
}
.box-img{
  display: flex;
  flex: 1;
}
.pro-box3,
.pro-box4 {
  flex-wrap: wrap;
}
.pro-box3 .item-con,
.pro-box4 .item-con {
  width: 100%;
  display: flex;
  margin-top: 15px;
}
.pro-box1 .item,
.item-con .item {
  width: 33%;
  display: flex;
  align-items: center;
}
.pro-box4 .item-con .item {
  width: 50%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
  border: 1px dashed #ddd;
  margin: 0 30px;
}
.avatar {
  width: 100px;
  height: 100px;
  display: block;
}
.box-card {
  margin-bottom: 20px;
  position: relative;
  padding: 20px;
}
p {
  /* text-align: left; */
  margin: 0;
  padding-left: 10px;
}
.required::before {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}
.desc-con{
  width: 100%;
  height: 6vh;
  position: relative;
  line-height: 3vh;
  color: #000;
  padding-right: 1vh;
  transition: all 1s;
}
.desc-con1{
  height:auto;
}
.desc-down{
  position: absolute;
  right: 0vh;
  bottom: 0.5vh;
  cursor: pointer;
}
</style>
<style>
  /**
  *图片放大右上角关闭按钮
  */
  .el-image-viewer__close i{
      font-size: 4vh;
      color: #fff;
  }
  .el-tree-node__content{
    height: 30px;
  }
  .el-tree-node__label{
    font-size: inherit;
  }
  @import '../../assets/css/common.css';
  .tips{
      display: flex;
      flex-direction: column;
      align-items: center;
      font-size: 14px;
      cursor: pointer;
    }
    .com-wage .el-form-item__content{
        text-align: left;
    }
    .com-wage .el-dialog__footer{
        text-align: center;
    }
</style>